import { gql } from '@apollo/client'
import { IMAGE_FRAGMENT } from '../fragments'

export const SABRE_GET_PRODUCT_IMAGES = gql`
  query GetProductImages($input: ProductImagesInput!) {
    productImages(input: $input) {
      count
      hasMore
      results {
        ...Image
      }
    }
  }
  ${IMAGE_FRAGMENT}
`
